module.exports = {
          srcSet: __webpack_public_path__ + "86409e6adb6f233d03d38a3cd8e5f09f-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "86409e6adb6f233d03d38a3cd8e5f09f-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "86409e6adb6f233d03d38a3cd8e5f09f-60.png",
          toString:function(){return __webpack_public_path__ + "86409e6adb6f233d03d38a3cd8e5f09f-60.png"},
          
          width: 60,
          height: 60
        }